import bracketsMixin from './bracketsMixin';
import ProppingItem from './ElvarliProppingItem';

export default class ElvarliShelfClothesRail extends bracketsMixin(
  ProppingItem
) {}
